import { render, staticRenderFns } from "./Recuperos.vue?vue&type=template&id=505cd18e"
import script from "./Recuperos.vue?vue&type=script&lang=js"
export * from "./Recuperos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports